/**
 * Search and filters for the schedule timeline header chrome row.
 */
import { ClipboardList, Search, Users } from "../../../components/icons/svg/outline";
import { useScheduleContext } from "../../../context/domain/planning/ScheduleContext";
import ScheduleFiltersPanel from "./ScheduleFiltersPanel";

const SCHEDULE_VIEW_OPTIONS = [
  { id: "scopes", label: "Scopes", Icon: ClipboardList },
  { id: "workers", label: "Workers", Icon: Users },
];

/**
 * Segmented schedule display toggle for scope labels versus default-crew initials.
 *
 * @returns {JSX.Element}
 */
function ScheduleViewModeToggle() {
  const { scheduleViewMode, setScheduleViewMode } = useScheduleContext();

  return (
    <div className="inline-flex shrink-0 rounded-md bg-gray-100 p-0.5">
      {SCHEDULE_VIEW_OPTIONS.map(({ id, label, Icon }, index) => {
        const active = scheduleViewMode === id;
        return (
          <button
            key={id}
            type="button"
            className={`inline-flex items-center gap-1.5 ${index === 0 ? "rounded-l-md" : "rounded-r-md"} px-2.5 py-1 text-xs font-medium focus:outline-none focus:ring-0 ${
              active
                ? "bg-teal-600 text-white shadow-sm"
                : "text-gray-700 hover:bg-white bg-white"
            }`}
            aria-pressed={active}
            onClick={() => setScheduleViewMode(id)}
          >
            <Icon className="h-4 w-4 shrink-0" aria-hidden />
            {label}
          </button>
        );
      })}
    </div>
  );
}

/**
 * Inline search + filters for the gap between the date range and navigation controls.
 *
 * @returns {JSX.Element}
 */
export default function ScheduleToolbar() {
  const { projectSearchQuery, setProjectSearchQuery } = useScheduleContext();

  return (
    <div className="flex min-w-0 flex-1 items-center gap-2">
      <div className="relative min-w-0 flex-1">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2.5">
          <Search className="h-4 w-4 text-gray-400" aria-hidden />
        </div>
        <input
          type="text"
          value={projectSearchQuery}
          onChange={(e) => setProjectSearchQuery(e.target.value)}
          placeholder="Search projects, groups, or scopes..."
          className="block w-full rounded-md border border-gray-300 bg-white py-0.5 pl-8 pr-2 text-sm leading-5 text-gray-900 placeholder-gray-500 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
          aria-label="Search projects, groups, or scopes"
        />
      </div>
      <ScheduleFiltersPanel />
      <ScheduleViewModeToggle />
    </div>
  );
}
